import TextMessageNotification from "./TextMessageNotification";
import ImageMessageNotification from "./ImageMessageNotification";
import {TW_VIDEO_TAG} from "../../twilio/constants";
import VideoCallNotification from "./VideoCallNotification";
import {MESSAGE_IMAGE_TAG} from "../../../../screens/message/constants";


export default function createNotification(notification, sender) {
  if (notification.text.startsWith(TW_VIDEO_TAG)) {
    return new VideoCallNotification(notification, sender);
  }

  if (notification.text.startsWith(MESSAGE_IMAGE_TAG)) {
    return new ImageMessageNotification(notification, sender);
  }

  return new TextMessageNotification(notification, sender);
}
